exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/_wks-ext.js
// module id = 304
// module chunks = 0